import { GetSearchProps_myCountry_currency } from "../../components/pages/SearchPage/queries/types/GetSearchProps";
import { CurrencyCode } from "../../types/graphql-global-types";
import {
  ListingCardFragment_originalPrice,
  ListingCardFragment_price,
  ListingCardFragment_rrp,
} from "../../graphql/fragments/types/ListingCardFragment";
import { Hit as AlgoliaHit, BaseHit } from "instantsearch.js";

type Currency = GetSearchProps_myCountry_currency;

const defaultCurrency: Currency = {
  code: CurrencyCode.AUD,
  conversionRateFromAud: 1,
  symbol: "$",
  symbolFirst: true,
  __typename: "Currency",
};

export interface HitRecord extends BaseHit {
  objectID: string;
  id: number;
  brand: string;
  brand_key: string;
  image: string;
  is_price_reduced: boolean;
  item_type: string;
  listing_path: string;
  listing_url: string;
  original_price_aud: number;
  price_aud: number;
  price_reduced_percentage_bucket: string;
  price_reduced_percentage: number;
  rrp_aud: number;
  size: string[];
  sold: boolean;
  title: string;
  category_id: string;
}

export type Hit = AlgoliaHit<HitRecord>;

export interface ListingCardData {
  id: number;
  brand: string | null;
  brandKey: string | null;
  title: string;
  isInMyCollections: boolean;
  unitType?: string;
  sold: boolean;
  url: string;
  path: string;
  price: ListingCardFragment_price | null;
  originalPrice: ListingCardFragment_originalPrice | null;
  isPriceReduced: boolean;
  rrp: ListingCardFragment_rrp | null;
  previewUrl: string | null;
  priceReducedPercentageBucket: string | null;
  priceReducedPercentage: number | null;
  size?: string[];
}

export function mapHitToListing(
  hit: Hit,
  allCollectionListingIds: Array<number> = [],
  currency: Currency = defaultCurrency
): ListingCardData {
  const id = Number(hit.id);
  const isInMyCollections = allCollectionListingIds.includes(id);
  const rrp: ListingCardData["rrp"] =
    hit.rrp_aud > 0
      ? {
          __typename: "Money",
          fractional: hit.rrp_aud * currency.conversionRateFromAud * 100,
          currency,
        }
      : null;

  return {
    id,
    previewUrl: hit.image,
    url: hit.listing_url,
    path: hit.listing_path,
    title: hit.title,
    brand: hit.brand,
    brandKey: hit.brand_key,
    sold: hit.sold,
    unitType: hit.item_type === "For Rent" ? "per occasion" : undefined,
    isInMyCollections,
    rrp,
    price: {
      __typename: "Money",
      fractional: hit.price_aud * currency.conversionRateFromAud * 100,
      currency,
    },
    originalPrice: hit.original_price_aud
      ? {
          __typename: "Money",
          fractional: Number(hit.original_price_aud * currency.conversionRateFromAud) * 100,
          currency,
        }
      : null,
    isPriceReduced: hit.is_price_reduced,
    priceReducedPercentageBucket: hit.price_reduced_percentage_bucket,
    priceReducedPercentage: hit.price_reduced_percentage,
    size: hit.size,
  };
}
